<template>
    <section class="hosting-cta-section">
        <h2>Switch to blazing fast web hosting</h2>
        <a :href="ctaAction" class="btn btn-default hosting-cta-button">Get Started Now</a>
    </section>
</template>

<script>
    import {link} from "../../core/helpers/assets";
    import Config from "../../config";

    export default {
        name: "HostingCtaSection",
        computed: {
            ctaAction() {
                return link(Config.urls.clientAreaUrl);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .hosting-cta-section {
        display: flex;
        flex-direction: row;
        padding: 50px 20px;
        justify-content: center;
        color: black;
        border-top: solid 1px #efefef;
        border-bottom: solid 1px #efefef;

        .hosting-cta-button {
            background-color: #0e324d;
            color: white;
            padding: 7px 15px;
            border-radius: 40px;
            margin-left: 25px
        }
    }


    @media screen and (max-width: 650px) {
        .hosting-cta-section {
            display: block;

            text-align: center;

            .hosting-cta-button {
                margin-top: 10px;
            }
        }
    }
</style>